// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-plan button-plan\"> <i class=\"fa fa-calendar\"></i> <span><!--ko text: Label--><!--/ko--></span> </a>";
// Exports
export default code;